// extracted by mini-css-extract-plugin
module.exports = {"initials":"PostProfileHeader_initials__kN11Y","initialsSmall":"PostProfileHeader_initialsSmall__QXEnr"};